module.exports = __webpack_public_path__ + "static/media/layIcon.7711907d.svg";